import React from "react"
import DfbRte from "../ui-kit/dfb_rte"
import DfbButton from "../ui-kit/dfb_button"
import CStatusHeadline from "../elements/c_status_headline"

const MUserPanel = ({
  headline,
  status,
  richtext,
  buttonLabel, // button can eiter have a link or onClick handler
  buttonLink,
  onButtonClick,
  children,
}) => {
  return (
    <div className="m-UserPanel-content">
      {headline && (
        <CStatusHeadline
          headline={headline}
          status={status}
          add_class="m-UserPanel-statusHeadline"
        />
      )}
      {richtext && <DfbRte text={richtext} add_class="m-UserPanel-richtext" />}

      {children}

      {buttonLabel && (
        <DfbButton
          text={buttonLabel}
          add_class="m-UserPanel-button"
          tagName={buttonLink ? "a" : "button"}
          link={buttonLink}
          onClick={onButtonClick}
        />
      )}
    </div>
  )
}

export default MUserPanel
